"use client";

import { useEffect } from "react";

// Root layout error — inline everything since the layout itself may be broken.
export default function GlobalRootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    fetch("/api/internal/error-report", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: error?.message || "Root layout error",
        digest: error?.digest,
        url: typeof window !== "undefined" ? window.location.href : "",
        route: "global-error",
      }),
    }).catch(() => {});
  }, [error]);

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>ExpiryDesk — something went wrong</title>
      </head>
      <body style={{ margin: 0 }}>
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "1.5rem",
            fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
            background: "#f0f7ff",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "400px",
              background: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "16px",
              padding: "2.25rem 2rem",
              boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
              textAlign: "center",
            }}
          >
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }} aria-hidden>🔧</div>

            <h1 style={{ fontSize: "1.2rem", fontWeight: 800, margin: "0 0 0.65rem", color: "#0c4a6e" }}>
              We hit a snag
            </h1>

            <p style={{ margin: "0 0 1.5rem", fontSize: "0.9375rem", lineHeight: 1.6, color: "#64748b" }}>
              Your stock data is safe. We&rsquo;ve been alerted and are on it. A refresh fixes most glitches.
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
              <button
                onClick={reset}
                style={{
                  width: "100%",
                  padding: "0.8rem",
                  background: "#0284c7",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: "0.9375rem",
                  border: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                  fontFamily: "inherit",
                }}
              >
                Try again
              </button>

              <a
                href="/dashboard"
                style={{
                  display: "block",
                  padding: "0.75rem",
                  border: "1.5px solid #cbd5e1",
                  borderRadius: "10px",
                  color: "#475569",
                  fontWeight: 600,
                  fontSize: "0.875rem",
                  textDecoration: "none",
                }}
              >
                Go to dashboard
              </a>
            </div>

            {error?.digest && (
              <p style={{ marginTop: "1.25rem", fontSize: "0.7rem", color: "#94a3b8", fontFamily: "monospace" }}>
                Ref: {error.digest}
              </p>
            )}
          </div>
        </div>
      </body>
    </html>
  );
}
